export const winConfig = {
    normal: {
        winTypes: [
            {
                minWinToBetRatio: 100,
                name: 'BigWinX100',
                sounds: ['bigwin'],
                duration: 18200
            },
            {
                minWinToBetRatio: 50,
                name: 'BigWinX50',
                sounds: ['bigwin'],
                duration: 18200
            },
            {
                minWinToBetRatio: 20,
                name: 'BigWinX20',
                sounds: ['bigwin'],
                duration: 18200
            },
            {
                minWinToBetRatio: 10,
                name: 'WinType6',
                sounds: ['win6'],
                duration: 10000
            },
            {
                minWinToBetRatio: 5,
                name: 'WinType5',
                sounds: ['win5'],
                duration: 6000
            },
            {
                minWinToBetRatio: 2,
                name: 'WinType4',
                sounds: ['win4a', 'win4b'],
                duration: 3000
            },
            {
                minWinToBetRatio: 1,
                name: 'WinType3',
                sounds: ['win3a', 'win3b'],
                duration: 1500
            },
            {
                minWinToBetRatio: 0.5,
                name: 'WinType2',
                sounds: ['win2a', 'win2b'],
                duration: 750
            },
            {
                minWinToBetRatio: 0.01,
                name: 'WinType1',
                sounds: ['win1a', 'win1b'],
                duration: 250
            }
        ],
        initial: {
            animation: [
                {
                    symbol: '0',
                    spine: 'wild',
                    animation: 'blue_moon_win_'
                },
                {
                    symbol: '1',
                    spine: 'pic_a',
                    animation: 'win_'
                },
                {
                    symbol: '2',
                    spine: 'pic_b',
                    animation: 'win_'
                },
                {
                    symbol: '3',
                    spine: 'pic_c',
                    animation: 'win_'
                },
                {
                    symbol: '4',
                    spine: 'royals',
                    animation: 'a_'
                },
                {
                    symbol: '5',
                    spine: 'royals',
                    animation: 'k_'
                },
                {
                    symbol: '6',
                    spine: 'royals',
                    animation: 'q_'
                },
                {
                    symbol: '7',
                    spine: 'royals',
                    animation: 'j_'
                },
                {
                    symbol: '8',
                    spine: 'royals',
                    animation: 't_'
                },
                {
                    symbol: '9',
                    spine: 'royals',
                    animation: 'n_'
                },
                {
                    symbol: '10',
                    spine: 'scatter',
                    animation: 'scatter_'
                },
                {
                    symbol: '11',
                    spine: 'wild',
                    animation: 'red_moon_win_'
                },
                {
                    symbol: '12',
                    spine: 'pic_a',
                    animation: 'double_win_'
                },
                {
                    symbol: '13',
                    spine: 'pic_b',
                    animation: 'double_win_'
                },
                {
                    symbol: '14',
                    spine: 'pic_c',
                    animation: 'double_win_'
                },
                {
                    symbol: '15',
                    spine: 'royals',
                    animation: 'a_double_'
                },
                {
                    symbol: '16',
                    spine: 'royals',
                    animation: 'k_double_'
                },
                {
                    symbol: '17',
                    spine: 'royals',
                    animation: 'q_double_'
                },
                {
                    symbol: '18',
                    spine: 'royals',
                    animation: 'j_double_'
                },
                {
                    symbol: '19',
                    spine: 'royals',
                    animation: 't_double_'
                },
                {
                    symbol: '20',
                    spine: 'royals',
                    animation: 'n_double_'
                },
                {
                    symbol: '21',
                    spine: 'wild',
                    animation: 'blue_moon_win_'
                },
                {
                    symbol: '*',
                    animation: 'symbolTweenAnimation'
                }
            ],
            time: 2000
        },
        regular: [
            {
                pattern: ['*', '*', '*', '*', '*'],
                animation: [
                    {
                        symbol: '0',
                        spine: 'wild',
                        animation: 'blue_moon_win_'
                    },
                    {
                        symbol: '1',
                        spine: 'pic_a',
                        animation: 'win_'
                    },
                    {
                        symbol: '2',
                        spine: 'pic_b',
                        animation: 'win_'
                    },
                    {
                        symbol: '3',
                        spine: 'pic_c',
                        animation: 'win_'
                    },
                    {
                        symbol: '4',
                        spine: 'royals',
                        animation: 'a_'
                    },
                    {
                        symbol: '5',
                        spine: 'royals',
                        animation: 'k_'
                    },
                    {
                        symbol: '6',
                        spine: 'royals',
                        animation: 'q_'
                    },
                    {
                        symbol: '7',
                        spine: 'royals',
                        animation: 'j_'
                    },
                    {
                        symbol: '8',
                        spine: 'royals',
                        animation: 't_'
                    },
                    {
                        symbol: '9',
                        spine: 'royals',
                        animation: 'n_'
                    },
                    {
                        symbol: '10',
                        spine: 'scatter',
                        animation: 'scatter_'
                    },
                    {
                        symbol: '11',
                        spine: 'wild',
                        animation: 'red_moon_win_'
                    },
                    {
                        symbol: '12',
                        spine: 'pic_a',
                        animation: 'double_win_'
                    },
                    {
                        symbol: '13',
                        spine: 'pic_b',
                        animation: 'double_win_'
                    },
                    {
                        symbol: '14',
                        spine: 'pic_c',
                        animation: 'double_win_'
                    },
                    {
                        symbol: '15',
                        spine: 'royals',
                        animation: 'a_double_'
                    },
                    {
                        symbol: '16',
                        spine: 'royals',
                        animation: 'k_double_'
                    },
                    {
                        symbol: '17',
                        spine: 'royals',
                        animation: 'q_double_'
                    },
                    {
                        symbol: '18',
                        spine: 'royals',
                        animation: 'j_double_'
                    },
                    {
                        symbol: '19',
                        spine: 'royals',
                        animation: 't_double_'
                    },
                    {
                        symbol: '20',
                        spine: 'royals',
                        animation: 'n_double_'
                    },
                    {
                        symbol: '21',
                        spine: 'wild',
                        animation: 'blue_moon_win_'
                    },
                    {
                        symbol: '*',
                        animation: 'symbolTweenAnimation'
                    }
                ],
                time: 2000
            }
        ]
    },
    turbo: {
        winTypes: [
            {
                minWinToBetRatio: 100,
                name: 'BigWinX100',
                sounds: ['bigwin'],
                duration: 18200
            },
            {
                minWinToBetRatio: 50,
                name: 'BigWinX50',
                sounds: ['bigwin'],
                duration: 18200
            },
            {
                minWinToBetRatio: 20,
                name: 'BigWinX20',
                sounds: ['bigwin'],
                duration: 18200
            },
            {
                minWinToBetRatio: 10,
                name: 'WinType6',
                sounds: ['win6'],
                duration: 10000
            },
            {
                minWinToBetRatio: 5,
                name: 'WinType5',
                sounds: ['win5'],
                duration: 6000
            },
            {
                minWinToBetRatio: 2,
                name: 'WinType4',
                sounds: ['win4a', 'win4b'],
                duration: 3000
            },
            {
                minWinToBetRatio: 1,
                name: 'WinType3',
                sounds: ['win3a', 'win3b'],
                duration: 1500
            },
            {
                minWinToBetRatio: 0.5,
                name: 'WinType2',
                sounds: ['win2a', 'win2b'],
                duration: 750
            },
            {
                minWinToBetRatio: 0.01,
                name: 'WinType1',
                sounds: ['win1a', 'win1b'],
                duration: 250
            }
        ],
        initial: {
            animation: [
                {
                    symbol: '0',
                    spine: 'wild',
                    animation: 'blue_moon_win_'
                },
                {
                    symbol: '1',
                    spine: 'pic_a',
                    animation: 'win_'
                },
                {
                    symbol: '2',
                    spine: 'pic_b',
                    animation: 'win_'
                },
                {
                    symbol: '3',
                    spine: 'pic_c',
                    animation: 'win_'
                },
                {
                    symbol: '4',
                    spine: 'royals',
                    animation: 'a_'
                },
                {
                    symbol: '5',
                    spine: 'royals',
                    animation: 'k_'
                },
                {
                    symbol: '6',
                    spine: 'royals',
                    animation: 'q_'
                },
                {
                    symbol: '7',
                    spine: 'royals',
                    animation: 'j_'
                },
                {
                    symbol: '8',
                    spine: 'royals',
                    animation: 't_'
                },
                {
                    symbol: '9',
                    spine: 'royals',
                    animation: 'n_'
                },
                {
                    symbol: '10',
                    spine: 'scatter',
                    animation: 'scatter_'
                },
                {
                    symbol: '11',
                    spine: 'wild',
                    animation: 'red_moon_win_'
                },
                {
                    symbol: '12',
                    spine: 'pic_a',
                    animation: 'double_win_'
                },
                {
                    symbol: '13',
                    spine: 'pic_b',
                    animation: 'double_win_'
                },
                {
                    symbol: '14',
                    spine: 'pic_c',
                    animation: 'double_win_'
                },
                {
                    symbol: '15',
                    spine: 'royals',
                    animation: 'a_double_'
                },
                {
                    symbol: '16',
                    spine: 'royals',
                    animation: 'k_double_'
                },
                {
                    symbol: '17',
                    spine: 'royals',
                    animation: 'q_double_'
                },
                {
                    symbol: '18',
                    spine: 'royals',
                    animation: 'j_double_'
                },
                {
                    symbol: '19',
                    spine: 'royals',
                    animation: 't_double_'
                },
                {
                    symbol: '20',
                    spine: 'royals',
                    animation: 'n_double_'
                },
                {
                    symbol: '21',
                    spine: 'wild',
                    animation: 'blue_moon_win_'
                },
                {
                    symbol: '*',
                    animation: 'symbolTweenAnimation'
                }
            ],
            time: 2000
        },
        regular: [
            {
                pattern: ['*', '*', '*', '*', '*'],
                animation: [
                    {
                        symbol: '0',
                        spine: 'wild',
                        animation: 'blue_moon_win_'
                    },
                    {
                        symbol: '1',
                        spine: 'pic_a',
                        animation: 'win_'
                    },
                    {
                        symbol: '2',
                        spine: 'pic_b',
                        animation: 'win_'
                    },
                    {
                        symbol: '3',
                        spine: 'pic_c',
                        animation: 'win_'
                    },
                    {
                        symbol: '4',
                        spine: 'royals',
                        animation: 'a_'
                    },
                    {
                        symbol: '5',
                        spine: 'royals',
                        animation: 'k_'
                    },
                    {
                        symbol: '6',
                        spine: 'royals',
                        animation: 'q_'
                    },
                    {
                        symbol: '7',
                        spine: 'royals',
                        animation: 'j_'
                    },
                    {
                        symbol: '8',
                        spine: 'royals',
                        animation: 't_'
                    },
                    {
                        symbol: '9',
                        spine: 'royals',
                        animation: 'n_'
                    },
                    {
                        symbol: '10',
                        spine: 'scatter',
                        animation: 'scatter_'
                    },
                    {
                        symbol: '11',
                        spine: 'wild',
                        animation: 'red_moon_win_'
                    },
                    {
                        symbol: '12',
                        spine: 'pic_a',
                        animation: 'double_win_'
                    },
                    {
                        symbol: '13',
                        spine: 'pic_b',
                        animation: 'double_win_'
                    },
                    {
                        symbol: '14',
                        spine: 'pic_c',
                        animation: 'double_win_'
                    },
                    {
                        symbol: '15',
                        spine: 'royals',
                        animation: 'a_double_'
                    },
                    {
                        symbol: '16',
                        spine: 'royals',
                        animation: 'k_double_'
                    },
                    {
                        symbol: '17',
                        spine: 'royals',
                        animation: 'q_double_'
                    },
                    {
                        symbol: '18',
                        spine: 'royals',
                        animation: 'j_double_'
                    },
                    {
                        symbol: '19',
                        spine: 'royals',
                        animation: 't_double_'
                    },
                    {
                        symbol: '20',
                        spine: 'royals',
                        animation: 'n_double_'
                    },
                    {
                        symbol: '21',
                        spine: 'wild',
                        animation: 'blue_moon_win_'
                    },
                    {
                        symbol: '*',
                        animation: 'symbolTweenAnimation'
                    }
                ],
                time: 2000
            }
        ]
    }
};
